<template>
    <div class="item-flags" v-if="flags.length > 0">
        <div class="item-flag" v-for="flag in flags" :key="flag.id">
            <span class="label">{{ translateByLocationLanguage(flag.name) }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    import { useArticleAttributesStore } from "@/data/stores/articleAttribute";
    import { useIdentityStore } from "@/data/stores/identity";

    import { isAttributeDisplayedTo } from "@/shared/helpers/AttributeHelper";
    import { translateByLocationLanguage } from "@/shared/localization/language";

    import { useKioskStore } from "@/app/stores/kiosk";

    const props = defineProps<{
        articleId: string;
        // set for an option: the top-level main item it is offered in
        mainArticleId?: string;
    }>();

    const articleAttributes = useArticleAttributesStore();
    const identity = useIdentityStore();
    const kiosk = useKioskStore();

    // the kiosk is operated by a guest even though the device itself may be signed in with
    // operator access, so it counts as an end user here
    const isOperatorView = computed(() => identity.hasOperatorAccess && !kiosk.isKioskMode);

    const flags = computed(() =>
        articleAttributes
            .flagAttributesForArticle(props.articleId, props.mainArticleId)
            .filter((flag) => isAttributeDisplayedTo(flag, isOperatorView.value))
    );
</script>
